export enum LocationEnum {
  FrankfurtAmMain = "FrankfurtAmMain",
  Stuttgart = "Stuttgart",
  Landau = "Landau",
  Koblenz = "Koblenz",
  München = "München",
  Kaiserslautern = "Kaiserslautern",
  Köln = "Köln",
  Pirmasens = "Pirmasens",
  Heilbronn = "Heilbronn",
}
